import React from 'react';
import { Logger } from 'utilities';
import type { FeedbackOptions, FeedbackWidgetInstance } from './FeedbackProvider.props';

// Extend the Window interface to include FeedbackWidget that is loaded from the script
declare global {
  interface Window {
    FeedbackWidget: {
      new (config: FeedbackOptions): FeedbackWidgetInstance;
      widget?: FeedbackWidgetInstance;
    };
  }
}

export const FeedbackProvider: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  React.useEffect(() => {
    const embedUrl = process.env.REACT_APP_SCALAR_FEEDBACK_EMBED_URL as string
    if (!embedUrl) {
      return;
    }
    const script = document.createElement('script');
    script.src = embedUrl;
    script.async = true;
    script.onload = () => {
      if (typeof window.FeedbackWidget === 'function') {
        try {
          window.FeedbackWidget.widget = new window.FeedbackWidget({
            projectKey: process.env.REACT_APP_SCALAR_FEEDBACK_API_PROJECT_ID as string,
            showFeedbackButton: false,
            enableSessionReplay: true,
            supportEmail: 'support@scalar.io',
            themeColors: {
              primaryColor: '#037de8',
              secondaryColor: '#65c687',
              darkColor: '#043a6e',
              errorColor: '#ff4070',
              successColor: '#037de8'
            }
          });
        } catch (error) {
          Logger.error('FeedbackWidget initialization error:', error);
        }
      }
    };

    document.body.appendChild(script);

    return () => {
      script.parentNode?.removeChild(script);
      if (window.FeedbackWidget.widget) {
        delete window.FeedbackWidget.widget;
      }
    };
  }, []);

  return <span>{children}</span>;
};


